import React from 'react'
import PropTypes from 'prop-types'
import { BoardsProvider } from './context/BoardsContext'
import { DragProvider } from './context/DragContext'
import BoardsPage from './components/BoardsPage'

function KanbanBoardsApp({ current_user_id, default_board_id, board_id }) {
  return (
    <BoardsProvider currentUserId={current_user_id} defaultBoardId={board_id || default_board_id}>
      <DragProvider>
        <BoardsPage />
      </DragProvider>
    </BoardsProvider>
  )
}

KanbanBoardsApp.propTypes = {
  current_user_id: PropTypes.number.isRequired,
  default_board_id: PropTypes.number,
  board_id: PropTypes.number
}

export default KanbanBoardsApp
